import * as yup from 'yup';

const ValidationSchema = yup.object().shape({
  reason: yup.string().required('Campo obrigatório').nullable(),
  comment: yup.string().max(255, 'Máximo de 255 caracteres').nullable(),
});

export default ValidationSchema;